import { schema } from 'normalizr';

//
// Template
//
export const template = new schema.Entity('templates');

//
// Teacher
//
export const teacher = new schema.Entity('teachers');

//
// Pin
//
export const pin = new schema.Entity('pins');

//
// Lesson
//
export const lesson = new schema.Entity('lessons', {
  pins: [ pin ]
});

//
// Class
//
export const cls = new schema.Entity('classes', {
  teachers: [ teacher ],
  lessons: [ lesson ]
});

//
// School
//
export const school = new schema.Entity('schools', {
  classes: [ cls ]
});

//
// User
//
export const user = new schema.Entity('users', {
  schools: [ school ],
  classes: [ cls ]
});

//
// Slide show
//
export const slideShow = new schema.Entity('slideShows');

export const activity = new schema.Entity('activities');

export const institution = new schema.Entity('institutions', {
  activities: [activity]
});

export const introduction = new schema.Entity('introductions');


// WEBPACK FOOTER //
// ./src/api/schema.js